// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var FastLevenshtein = require("fast-levenshtein");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function fromString(urlString) {
  return Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(urlString), (function (nativeUrl) {
                return {
                        nativeUrl: nativeUrl,
                        protocol: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.protocol),
                        username: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.username),
                        password: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.password),
                        hostname: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.hostname),
                        port: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.port),
                        pathname: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.pathname),
                        searchParams: Belt_MapString.fromArray(Js_dict.entries(Object.fromEntries(nativeUrl.searchParams.entries()))),
                        hash: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.hash)
                      };
              }));
}

function toString(url) {
  return url.nativeUrl.href;
}

var Url = {
  fromString: fromString,
  toString: toString
};

function calcLevenshteinBtwnComponents(pluckComponent, urlA, urlB) {
  var match = Curry._1(pluckComponent, urlA);
  var match$1 = Curry._1(pluckComponent, urlB);
  if (match !== undefined) {
    if (match$1 !== undefined) {
      return FastLevenshtein.get(match, match$1);
    } else {
      return FastLevenshtein.get("", match);
    }
  } else if (match$1 !== undefined) {
    return FastLevenshtein.get("", match$1);
  } else {
    return 0;
  }
}

function calcLevenshteinBtwnProtocols(param, param$1) {
  return calcLevenshteinBtwnComponents((function (url) {
                return url.protocol;
              }), param, param$1);
}

function calcLevenshteinBtwnUsernames(param, param$1) {
  return calcLevenshteinBtwnComponents((function (url) {
                return url.username;
              }), param, param$1);
}

function calcLevenshteinBtwnPasswords(param, param$1) {
  return calcLevenshteinBtwnComponents((function (url) {
                return url.password;
              }), param, param$1);
}

function calcLevenshteinBtwnPorts(param, param$1) {
  return calcLevenshteinBtwnComponents((function (url) {
                return url.port;
              }), param, param$1);
}

function calcLevenshteinBtwnHashes(param, param$1) {
  return calcLevenshteinBtwnComponents((function (url) {
                return url.hash;
              }), param, param$1);
}

function calcLevenshteinBtwnStringLists(listA, listB) {
  var str;
  var rest;
  if (listA) {
    var remainingA = listA.tl;
    var strA = listA.hd;
    if (listB) {
      return FastLevenshtein.get(strA, listB.hd) + calcLevenshteinBtwnStringLists(remainingA, listB.tl) | 0;
    }
    str = strA;
    rest = remainingA;
  } else {
    if (!listB) {
      return 0;
    }
    str = listB.hd;
    rest = listB.tl;
  }
  return FastLevenshtein.get(str, "") + calcLevenshteinBtwnStringLists(rest, /* [] */0) | 0;
}

function calcLevenshteinBtwnHostnames(urlA, urlB) {
  var partsA = List.rev(StringUtils$SmartcutsMacros.split(".", OptionUtils$SmartcutsMacros.withDefault("", urlA.hostname)));
  var partsB = List.rev(StringUtils$SmartcutsMacros.split(".", OptionUtils$SmartcutsMacros.withDefault("", urlB.hostname)));
  return calcLevenshteinBtwnStringLists(partsA, partsB);
}

function calcLevenshteinBtwnPathnames(urlA, urlB) {
  var partsA = StringUtils$SmartcutsMacros.split("/", OptionUtils$SmartcutsMacros.withDefault("", urlA.pathname));
  var partsB = StringUtils$SmartcutsMacros.split("/", OptionUtils$SmartcutsMacros.withDefault("", urlB.pathname));
  return calcLevenshteinBtwnStringLists(partsA, partsB);
}

function calcLevenshteinBtwnSearchParams(urlA, urlB) {
  var allKeys = Belt_SetString.toList(Belt_SetString.union(Belt_SetString.fromArray(Belt_MapString.keysToArray(urlA.searchParams)), Belt_SetString.fromArray(Belt_MapString.keysToArray(urlB.searchParams))));
  return Belt_List.reduce(allKeys, 0, (function (accumLevenshteinDistance, key) {
                var match = Belt_MapString.get(urlA.searchParams, key);
                var match$1 = Belt_MapString.get(urlB.searchParams, key);
                return accumLevenshteinDistance + (
                        match !== undefined ? (
                            match$1 !== undefined ? FastLevenshtein.get(match, match$1) : FastLevenshtein.get(key + match, "")
                          ) : (
                            match$1 !== undefined ? FastLevenshtein.get(key + match$1, "") : 0
                          )
                      ) | 0;
              }));
}

function calcLevenshteinDistance(urlA, urlB) {
  return ((((((calcLevenshteinBtwnUsernames(urlA, urlB) + calcLevenshteinBtwnUsernames(urlA, urlB) | 0) + calcLevenshteinBtwnPasswords(urlA, urlB) | 0) + calcLevenshteinBtwnPorts(urlA, urlB) | 0) + calcLevenshteinBtwnHostnames(urlA, urlB) | 0) + calcLevenshteinBtwnPathnames(urlA, urlB) | 0) + calcLevenshteinBtwnSearchParams(urlA, urlB) | 0) + calcLevenshteinBtwnHashes(urlA, urlB) | 0;
}

function sortUrlsByLevenshteinDistanceAsc(relativeToUrl, urlStrings) {
  var url = fromString(relativeToUrl);
  var relativeUrl;
  if (url !== undefined) {
    relativeUrl = url;
  } else {
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: relativeToUrl,
          Error: new Error()
        };
  }
  var arg = Belt_Array.map(urlStrings, (function (urlStr) {
          var url$p = fromString(urlStr);
          if (url$p !== undefined) {
            return url$p;
          }
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                _1: urlStr,
                Error: new Error()
              };
        }));
  return Belt_Array.map((function (param) {
                  return ArrayUtils$SmartcutsMacros.sort(param, arg);
                })(function (urlA, urlB) {
                  return calcLevenshteinDistance(relativeUrl, urlA) - calcLevenshteinDistance(relativeUrl, urlB) | 0;
                }), toString);
}

var NativeUrl;

exports.NativeUrl = NativeUrl;
exports.Url = Url;
exports.calcLevenshteinBtwnComponents = calcLevenshteinBtwnComponents;
exports.calcLevenshteinBtwnProtocols = calcLevenshteinBtwnProtocols;
exports.calcLevenshteinBtwnUsernames = calcLevenshteinBtwnUsernames;
exports.calcLevenshteinBtwnPasswords = calcLevenshteinBtwnPasswords;
exports.calcLevenshteinBtwnPorts = calcLevenshteinBtwnPorts;
exports.calcLevenshteinBtwnHashes = calcLevenshteinBtwnHashes;
exports.calcLevenshteinBtwnStringLists = calcLevenshteinBtwnStringLists;
exports.calcLevenshteinBtwnHostnames = calcLevenshteinBtwnHostnames;
exports.calcLevenshteinBtwnPathnames = calcLevenshteinBtwnPathnames;
exports.calcLevenshteinBtwnSearchParams = calcLevenshteinBtwnSearchParams;
exports.calcLevenshteinDistance = calcLevenshteinDistance;
exports.sortUrlsByLevenshteinDistanceAsc = sortUrlsByLevenshteinDistanceAsc;
/* fast-levenshtein Not a pure module */
